module.exports = __webpack_public_path__ + "static/media/KMH_5002.6ecc3e34.jpg";